export default __webpack_public_path__ + "static/media/sdg-2-load.9a0927db.png";